import FormGroup from '@/core/components/FormGroup'
import { Input } from '@/components/ui'
import { ContinuousSpendingQuestConfigDto } from '@/common/models/gamification'

import { TokenPoolSelect } from './TokenPoolSelect'

interface ContinuousSpendingConfigFieldsProps {
  value: ContinuousSpendingQuestConfigDto
  onChange: (next: ContinuousSpendingQuestConfigDto) => void
  editionId: string
}

/**
 * Editor for a CONTINUOUS_SPENDING quest's config: a single points-per-unit rate (may be fractional).
 * No completion threshold and no card filter — the quest never completes and credits
 * `floor(spentAmount × pointsPerUnit)` points on every wristband spend of real (non-reward) funds.
 */
export const ContinuousSpendingConfigFields = ({
  value,
  onChange,
  editionId,
}: ContinuousSpendingConfigFieldsProps) => {
  const pointsPerUnitError =
    value.pointsPerUnit === undefined || value.pointsPerUnit <= 0

  return (
    <div className="space-y-6">
      <FormGroup
        label="Points per unit"
        error={
          pointsPerUnitError ? 'Required and must be greater than 0' : undefined
        }
      >
        <div>
          <Input
            type="number"
            step="0.0001"
            min="0"
            placeholder="e.g. 10 (points per 1 unit of default currency spent)"
            isInvalid={pointsPerUnitError}
            value={value.pointsPerUnit ?? ''}
            onChange={(e) =>
              onChange({
                ...value,
                pointsPerUnit:
                  e.target.value === '' ? undefined : Number(e.target.value),
              })
            }
          />
          <span className="mt-1 block text-xs text-monochrome-2">
            Points earned per 1 unit of the festival's default currency spent
            (real funds only — reward spending is excluded). Each spend credits
            floor(amount × rate). Decimals allowed.
          </span>
        </div>
      </FormGroup>

      <TokenPoolSelect
        editionId={editionId}
        value={value.availableTokenPoolId}
        onChange={(availableTokenPoolId) =>
          onChange({ ...value, availableTokenPoolId })
        }
      />
    </div>
  )
}
